import React from 'react';
import { Box, Typography } from 'components/index';

const FallbackUI = () => {
  return (
    <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center' height='100vh' width='100vw'>
      <Typography variant='h4'>An error has occurred. We regret the inconvenience! Please refresh the page and try again!</Typography>
    </Box>
  );
};

export default FallbackUI;
